import { RiAdminLine } from "react-icons/ri"

const UserFullName = ({user, className}) => {
  return (
      <span className={` ${className}`}>{user?.firstName|| user?.lastName ? `${user?.firstName} ${user?.lastName}` : null}</span>
  )
}

export default UserFullName